import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { useAuth } from './auth/AuthContext';
import LoadingSpinner from './Loader';
import { Box } from '@mui/material';

const ProtectedRoute = ({ requiredRole = [] }) => {
  const { isAuthenticated, userRole, isLoading } = useAuth();
  const location = useLocation();

  // Show loading spinner while authentication state is loading
  if (isLoading) {
    return <LoadingSpinner fullPage />;
  }

  // Redirect to login if not authenticated
  if (!isAuthenticated) {
    return <Navigate to="/user/login" state={{ from: location }} replace />;
  }

  // Check if user has required role (if any roles are specified)
  if (requiredRole.length > 0 && userRole) {
    const allowedRoles = Array.isArray(requiredRole)
      ? requiredRole
      : [requiredRole];

    if (!allowedRoles.includes(userRole)) {
      return <Navigate to="/unauthorized" replace />;
    }
  }

  // Render child routes if authenticated and authorized
  return <Outlet />;
};

export default ProtectedRoute;